import { Checkbox as MCheckbox, CheckboxProps } from '@mui/material'

interface CustomCheckboxProps extends CheckboxProps {
  label?: string
}
export const Checkbox: React.FC<CustomCheckboxProps> = (props) => {
  return <MCheckbox {...props} />
}
